// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audio-player {
    background: #191818;
    padding: 10px 20px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: white;
    width: 100%;
    /* max-width: 400px; */
    min-width: 0;
    box-sizing: border-box;
  }
  
  @media (max-width: 900px) {
    .audio-player {
      max-width: 100%;
      width: 100%;
      padding: 10px 8px;
      gap: 8px;
    }
  }
  
  @media (max-width: 600px) {
    .audio-player {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
      max-width: 100%;
      width: 100%;
      padding: 10px 4px;
    }
    .progress-bar {
      width: 100%;
      min-width: 0;
    }
    .circle-btn, .mute-btn {
      align-self: center;
    }
    .time {
      width: auto;
      min-width: 32px;
      font-size: 13px;
      text-align: left;
    }
    .circle-btn {
      width: 38px;
      height: 38px;
      font-size: 15px;
    }
  }
  
  @media (max-width: 400px) {
    .audio-player {
      padding: 6px 1px;
      gap: 4px;
    }
    .circle-btn {
      width: 28px;
      height: 28px;
      font-size: 12px;
    }
    .progress-bar {
      height: 3px;
    }
  }
  
  .circle-btn {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    background: #444444;
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    cursor: pointer;
    transition: width 0.2s, height 0.2s, font-size 0.2s;
    padding: 0px;
  }
  
  .progress-bar {
    flex: 1 1;
    appearance: none;
    height: 5px;
    background: #101010;
    border-radius: 3px;
    outline: none;
    min-width: 60px;
    max-width: 100%;
  }
  
  .progress-bar::-webkit-slider-thumb {
    appearance: none;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background: white;
    cursor: pointer;
    border: 2px solid #8B8B8B;
  }
  
  .time {
    font-size: 14px;
    width: 45px;
    text-align: center;
  }
  
  .mute-btn {
    background: none;
    border: none;
    color: white;
    font-size: 16px;
    cursor: pointer;
    display: flex;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/ui/commentSection/audioPlayer/AudioPlayer.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE;MACE,eAAe;MACf,WAAW;MACX,iBAAiB;MACjB,QAAQ;IACV;EACF;;EAEA;IACE;MACE,sBAAsB;MACtB,oBAAoB;MACpB,QAAQ;MACR,eAAe;MACf,WAAW;MACX,iBAAiB;IACnB;IACA;MACE,WAAW;MACX,YAAY;IACd;IACA;MACE,kBAAkB;IACpB;IACA;MACE,WAAW;MACX,eAAe;MACf,eAAe;MACf,gBAAgB;IAClB;IACA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;EACF;;EAEA;IACE;MACE,gBAAgB;MAChB,QAAQ;IACV;IACA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;IACA;MACE,WAAW;IACb;EACF;;EAEA;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,mDAAmD;IACnD,YAAY;EACd;;EAEA;IACE,SAAO;IAEP,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,eAAe;EACjB;;EAEA;IAEE,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;EACf","sourcesContent":[".audio-player {\n    background: #191818;\n    padding: 10px 20px;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: white;\n    width: 100%;\n    /* max-width: 400px; */\n    min-width: 0;\n    box-sizing: border-box;\n  }\n  \n  @media (max-width: 900px) {\n    .audio-player {\n      max-width: 100%;\n      width: 100%;\n      padding: 10px 8px;\n      gap: 8px;\n    }\n  }\n  \n  @media (max-width: 600px) {\n    .audio-player {\n      flex-direction: column;\n      align-items: stretch;\n      gap: 8px;\n      max-width: 100%;\n      width: 100%;\n      padding: 10px 4px;\n    }\n    .progress-bar {\n      width: 100%;\n      min-width: 0;\n    }\n    .circle-btn, .mute-btn {\n      align-self: center;\n    }\n    .time {\n      width: auto;\n      min-width: 32px;\n      font-size: 13px;\n      text-align: left;\n    }\n    .circle-btn {\n      width: 38px;\n      height: 38px;\n      font-size: 15px;\n    }\n  }\n  \n  @media (max-width: 400px) {\n    .audio-player {\n      padding: 6px 1px;\n      gap: 4px;\n    }\n    .circle-btn {\n      width: 28px;\n      height: 28px;\n      font-size: 12px;\n    }\n    .progress-bar {\n      height: 3px;\n    }\n  }\n  \n  .circle-btn {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 50%;\n    background: #444444;\n    color: white;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    cursor: pointer;\n    transition: width 0.2s, height 0.2s, font-size 0.2s;\n    padding: 0px;\n  }\n  \n  .progress-bar {\n    flex: 1;\n    -webkit-appearance: none;\n    appearance: none;\n    height: 5px;\n    background: #101010;\n    border-radius: 3px;\n    outline: none;\n    min-width: 60px;\n    max-width: 100%;\n  }\n  \n  .progress-bar::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    height: 16px;\n    width: 16px;\n    border-radius: 50%;\n    background: white;\n    cursor: pointer;\n    border: 2px solid #8B8B8B;\n  }\n  \n  .time {\n    font-size: 14px;\n    width: 45px;\n    text-align: center;\n  }\n  \n  .mute-btn {\n    background: none;\n    border: none;\n    color: white;\n    font-size: 16px;\n    cursor: pointer;\n    display: flex;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
